import { Icon, Tooltip } from "@findemdev/maui";
import {
  CellText,
  ColumnHeader,
  SortableColumnHeader,
} from "../../RaasClientPortal.styled";
import type { ISortConfig, IProjectRow, SortableColumnKey, SortOrder } from "../../types";

interface IProjectHeaderCellProps {
  column: { key: string; label: string };
}

export const ProjectHeaderCell = ({ column }: IProjectHeaderCellProps) => (
  <ColumnHeader $emphasis={column.key === "project"}>
    {column.label}
  </ColumnHeader>
);

interface ISortableHeaderCellProps {
  columnKey: SortableColumnKey;
  label: string;
  disabled?: boolean;
  sortConfig: ISortConfig | null;
  onSort: (field: SortableColumnKey, order: SortOrder | null) => void;
}

export const SortableHeaderCell = ({
  columnKey,
  disabled = false,
  label,
  sortConfig,
  onSort,
}: ISortableHeaderCellProps) => {
  const isActive = sortConfig?.field === columnKey;
  // 3-state cycle: none → asc → desc → none (null clears the sort)
  const nextOrder: SortOrder | null = !isActive ? "asc" : sortConfig?.order === "asc" ? "desc" : null;

  return (
    <SortableColumnHeader
      $active={isActive}
      disabled={disabled}
      onClick={(e) => { e.stopPropagation(); onSort(columnKey, nextOrder); }}
      type="button"
    >
      {label}
      {isActive ? (
        <Icon icon={sortConfig?.order === "asc" ? "arrow_upward" : "arrow_downward"} $size={14} />
      ) : (
        <Icon icon="unfold_more" $size={14} />
      )}
    </SortableColumnHeader>
  );
};

interface IProjectNameCellProps {
  row: IProjectRow;
}

export const ProjectNameCell = ({ row }: IProjectNameCellProps) => (
  <Tooltip title={row.projectNameLabel}>
    <CellText $emphasis>{row.projectNameLabel}</CellText>
  </Tooltip>
);
